export default "__VITE_ASSET__CMtPtYrE__"